<template>
	<div v-if="show" :class="slideInClass">
		<nav v-if="!loading && fuzzyMatrix">
			<template
				v-for="item in grouped"
			>
				<h4>{{ item.area.label }}</h4>
				<ul>
					<li
						v-for="group in item.groups"
						:key="group.id"
						:class="[
							'more-left-padding',
							{'active': selectedGroup && selectedGroup.id === group.id},
							{'disabled': !hasItems(group)},
							{'completed': isFiltered(group)}
						]"
					>
						<a :href="hasItems(group) ? '#' : ''" @click.prevent="selectGroup(group)">
							<Icon v-if="isFiltered(group)" icon="checkmark"/>
							<span class="label">
								{{ group.inquiry }}
							</span>
							<span v-if="!hasItems(group)" class="sublabel">Derzeit keine</span>
						</a>
					</li>
				</ul>
			</template>
		</nav>
		<div class="edit-area">
			<header class="titled">
				<div v-if="!loading">
					<h1>{{ selectedGroup ? selectedGroup.inquiry : '' }}</h1>
				</div>
				<div class="close-container">
					<a href="#" @click.prevent="closeFan(false)">
						<Icon icon="close"/>
					</a>
				</div>
			</header>
			<main class="scrollbar-check">
				<Loading v-if="loading"/>
				<template v-else>
					<div v-if="!selectedGroup">Wähle links aus was du genauer filtern möchtest.</div>
					<div v-else>
						<Group
							:group="selectedGroup"
						/>
					</div>
				</template>
			</main>
			<footer v-if="!loading">
				<Button
					text="Ergebnisse anzeigen"
					icon="checkmark"
					@click="closeFan(true)"
				/>
			</footer>
		</div>
	</div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import Icon from "@/vue/icon/Icon"
import Loading from "@/vue/common/Loading";
import Button from "@/vue/common/Button";
import Get from "@/api/customer/job-profile/applicant/fuzzy-matrix/Get"
import {getClasses} from "@/helper/layout/Fan";
import {OPEN_FAN_KEY} from "@/store/job-profile/fuzzy-matrix";
import Group from "./Group"
import {isDefined} from "@/helper/Value";

export default {

	components: {
		Group,
		Button,
		Loading,
		Icon,
	},

	data ()
	{
		return {
			loading: true,
			fuzzyMatrix: undefined,
			selectedGroup: undefined,
		};
	},

	computed: {
		...mapState('jobProfile/fuzzyMatrix', [
			'show',
			'jobProfile',
			'filterGroups'
		]),
		...mapState('layout', ['fanLevelClasses']),
		slideInClass ()
		{
			return getClasses({
				fanLevelClasses: this.fanLevelClasses,
				key: OPEN_FAN_KEY,
				extraClasses: ['job-profile-fuzzy-matrix']
			});
		},
		grouped ()
		{
			if (!this.fuzzyMatrix)
			{
				return [];
			}

			let grouped = {};

			_.forEach(this.fuzzyMatrix.groups, group =>
			{
				const area = group.area;

				if (!grouped[area.id])
				{
					grouped[area.id] = {
						area,
						groups: []
					};
				}

				grouped[area.id].groups.push({
					id: group.id,
					inquiry: group.inquiry,
					items: group.items,
				});
			});

			return _.values(grouped);
		}
	},

	methods: {
		...mapActions('jobProfile/fuzzyMatrix', [
			'close'
		]),
		hasItems (group)
		{
			return group.items.length > 0 && _.sumBy(group.items, 'count') > 0;
		},
		selectGroup (group)
		{
			if (!this.hasItems(group))
			{
				return;
			}

			// use $nextTick to prevent "reusage" of Group component
			this.selectedGroup = null;

			this.$nextTick(() => this.selectedGroup = group);
		},
		isFiltered (group)
		{
			return isDefined(
				_.find(this.filterGroups, item => item.group.id === group.id)
			)
		},
		closeFan (confirm)
		{
			this.close({
				confirm
			});
		},
		async loadFuzzyMatrix ()
		{
			this.loading = true;

			const response = await new Get()
				.setJobProfileId(this.jobProfile.id)
				.call();

			this.fuzzyMatrix = response.data;

			this.loading = false;
		},
	},

	watch: {
		jobProfile (jobProfile)
		{
			if (jobProfile)
			{
				this.loadFuzzyMatrix();
			}
		},
	}
}
</script>
